import React from 'react';
import MemberAuthGate from '../auth/MemberAuthGate';
import MyGearApp from './MyGearApp';
import PrescribedBurnGearHandoff from './PrescribedBurnGearHandoff';
import OfflineInventoryWarmup from './OfflineInventoryWarmup';
import IndividualRemsMyGear from '../rems/IndividualRemsMyGear';

function prescribedBurnId() {
  if (typeof window === 'undefined') return '';
  try { return String(new URLSearchParams(window.location.search).get('burn') || '').trim(); }
  catch (_) { return ''; }
}

function individualRems(profile) {
  return ['rems_temporary', 'rems_permanent'].includes(String(profile?.member_kind || ''));
}

export default function TrackingProtected() {
  const burnId = prescribedBurnId();
  return (
    <MemberAuthGate>
      {(profile, session) => (
        <>
          <OfflineInventoryWarmup member={profile} />
          {individualRems(profile)
            ? <IndividualRemsMyGear member={profile} />
            : burnId
              ? <PrescribedBurnGearHandoff member={profile} burnId={burnId} />
              : <MyGearApp member={profile} session={session} />}
        </>
      )}
    </MemberAuthGate>
  );
}
